import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import useMoyasarHook from "@/pages/checkout/CheckoutV2/hooks/useMoyasarHook";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import useIsWebView from "@hooks/useIsWebview";
import MobileHeaderwithCancleFunction from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithCancleFunction/MobileHeaderwithCancleFunction";
import "@/pages/checkout/moyasar/styles.css";
import { useEffect } from "react";
import useWebView from "@hooks/useWebview";
var SESSION_STORAGE_KEY = "warranty_moyasar_session";
export var storeWarrantySession = function storeWarrantySession(session) {
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
};
var MOYASAR_DIV_ID = "warranty-moyasar-payment";
var WarrantyPaymentForm = function WarrantyPaymentForm(_ref) {
  var paymentSession = _ref.paymentSession;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  useMoyasarHook({
    divSelector: "#".concat(MOYASAR_DIV_ID),
    paymentSession: paymentSession,
    events: {
      on_initiating: function () {
        var _on_initiating = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                return _context.a(2, true);
            }
          }, _callee);
        }));
        function on_initiating() {
          return _on_initiating.apply(this, arguments);
        }
        return on_initiating;
      }(),
      on_completed: function () {
        var _on_completed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        function on_completed() {
          return _on_completed.apply(this, arguments);
        }
        return on_completed;
      }()
    },
    template: {
      payButtonText: tShort("warranty/confirm_pay", {
        ns: "web_tracking"
      })
    },
    internvalTimeoutSeconds: 60
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "container m-auto "
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full md:mt-32 m-auto px-2 md:p-10 md:pb-24 pb-20 rounded-2xl max-w-[665px]  md:shadow-[0_0_10px_rgba(188,188,188,0.4)] md:border-solid md:border-[1px] border-gray-200"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[#484848] md:text-start text-center mt-10 md:px-10 md:mt-2 mb-6 md:mb-10 text-lg md:text-xl font-bold"
  }, tShort("warranty/choose_payment", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    id: MOYASAR_DIV_ID,
    className: "w-full"
  })));
};
var WarrantyMoyasarPaymentPage = function WarrantyMoyasarPaymentPage() {
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var isWebview = useIsWebView();
  var webview = useWebView();
  var _useTranslation2 = useTranslation(),
    tShort = _useTranslation2.tShort;
  useEffect(function () {
    webview.showTitleBar(true)["catch"](function () {});
  }, [isWebview]);
  var raw = __IS_CSR__ ? sessionStorage.getItem(SESSION_STORAGE_KEY) : null;
  var paymentSession = raw ? JSON.parse(raw) : null;
  if (!paymentSession) {
    if (__IS_CSR__) navigateToHard("/tracking-landing");
    return null;
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    disableLoader: true,
    headHideLinks: true,
    authenticationMsg: true,
    hideFooterWithoutAuthMsg: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: !isWebview && /*#__PURE__*/React.createElement(MobileHeaderwithCancleFunction, {
      title: tShort("warranty/car_warranty_mobile", {
        ns: "web_tracking"
      }),
      buttonFunction: function buttonFunction() {
        return history.back();
      }
    })
  }, /*#__PURE__*/React.createElement(WarrantyPaymentForm, {
    paymentSession: paymentSession
  }));
};
export default WarrantyMoyasarPaymentPage;